import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Button from '../../../components/Button'
import FeaturedCard from '../../../components/FeaturedCard'
import { ENDPOINT, GO_DE_GQL_BACKEND_URL, Routes } from '../../../constants'
import { useAuth } from '../../../contexts/AuthContext'
import { FeaturedProps } from '../../../types/featured'
import { FetchApi } from '../../../api/fetch';

interface DraggableLocation {
   droppableId: string;
   index: number;
}

interface Combine {
   draggableId: string;
   droppableId: string;
}

function AdminFeaturedCollection() {
   const { getUserJWT, setIsLoadingOverlayDisplay } = useAuth()
   const [featured, setFeatured] = useState<FeaturedProps[]>([])
   const { push } = useHistory()
   useEffect(() => {
      getFeatured()
   }, [])


   const getFeatured = async () => {
      const JWT = await getUserJWT()
      setIsLoadingOverlayDisplay(true)

      try {
         const feat = await FetchApi( {
            endpoint:GO_DE_GQL_BACKEND_URL,
            method: "POST",
            body:  ({
               query: `{
                  featuredProject {
                     nodes {
                        description
                        id
                        name
                        position
                        projectUrl
                        thumbnailUrl
                      }
                   }
               }`,
               variables: {}
            })
         })
         const sorted = feat?.data?.featuredProject?.nodes?.sort((a: FeaturedProps, b: FeaturedProps) => a.position - b.position)
         setFeatured(sorted)
      } catch (error) {
         // :TODO
         // add error toast
         console.log(error);

      }
      setIsLoadingOverlayDisplay(false)

   }

   const saveFeatured = async (item: FeaturedProps, newPos: number, id?: string) => {
      const userJWT = await getUserJWT()


      try {
         let response: any = FetchApi({
            endpoint:`${ENDPOINT.BASE_ENDPOINT}/featured_project/${id}`, 
            method: "PATCH",
            JWT:userJWT,
            body:  ({ ...item, position: newPos })
         })
        push(Routes.FEATURED_COLLECTION)
      } catch (error) {
         console.log('something went wrong');
      }
   }


   const onDragEnd = (result: any) => {
      // dropped outside the list
      if (!result.destination) {
         return;
      }
      const newItems = [...featured];
      const [reordered] = newItems.splice(result.source.index, 1);
      newItems.splice(result.destination.index, 0, reordered);
      setFeatured(newItems)
      // saveFeatured(result.source.draggableId, reordered, result.destination.index)
      saveFeatured(reordered, result.destination.index + 1, reordered.id)

   }
   return (
      <div className='w-11/12 m-auto my-6'>
         <div className="mt-0 mb-12 flex flex-row justify-between items-center sm:flex-row">
            <h1 className="font-semibold text-3xl text-left">
               Featured Projects (Homepage)
            </h1>
            <div className="w-full sm:w-auto flex items-center space-x-4">
               <Link to={Routes.MANAGE_FEATURED}>
                  <Button
                     type="button"
                     className="mb-0 sm:mb-2 w-auto btn bg-gradient text-kyzzen-primary text-sm font-medium flex items-center"
                  >
                     Create New
                  </Button>
               </Link>

            </div>
         </div>
         <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId='featured'>
               {(provided) => (
                  <div 
                     className=''
                     {...provided.droppableProps}
                     ref={provided.innerRef}
                  // style={getListStyle(snapshot.isDraggingOver)}
                  >
                     {
                        featured?.map((item: FeaturedProps, index: number) => (
                           <Draggable key={index} draggableId={index.toString()} index={index}>
                              {(provided) => (
                                 <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                 >
                                    <FeaturedCard key={item?.id} data={item} getFeatured={getFeatured} />
                                 </div>
                              )}
                           </Draggable>
                        ))
                     }
                     {provided.placeholder}
                  </div>
               )}
            </Droppable>
         </DragDropContext>
      </div>
   )
}

export default AdminFeaturedCollection